// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationSentSignOthers } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationSentSignOthersStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationSentSignOthers {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationSentSignOthersStage.js